import { FC, useEffect, useState } from 'react';

type MapMarkerProps = google.maps.MarkerOptions & {
  label?: string;
};

export const MapMarker: FC<MapMarkerProps> = ({ label, ...options }) => {
  const [marker, setMarker] = useState<google.maps.Marker>();

  useEffect(() => {
    if (!marker) {
      setMarker(new google.maps.Marker());
    }

    return () => {
      if (marker) {
        marker.setMap(null);
      }
    };
  }, [marker]);

  useEffect(() => {
    if (marker) {
      const markerOptions = label
        ? {
            ...options,
            label: {
              text: label,
              color: 'black',
              fontSize: '14px',
              fontWeight: 'bold',
              className: 'custom-marker-label',
            },
          }
        : options;

      marker.setOptions(markerOptions);
    }
  }, [marker, options, label]);

  return null;
};
